import React, { Component } from 'react'

import {GenericTable} from '../../Utils'

class ParkingRemove extends Component {

    constructor(props){
        super(props)
        this.state = {
            parkingEntries: []
        }
        this.deleteRecord = this.deleteRecord.bind(this)
        this.headers = [
            {name: "Placa", small: true},
            {name: "Entrada", small: true, render: 'date-time'},
            {name: "", small: true, render: 'link', func: this.deleteRecord}
        ]

        this.getTableData = this.getTableData.bind(this)
    }

    deleteRecord(recordIndex){
        const {onDeleteRecord} = this.props
        const {parkingEntries} = this.state
        onDeleteRecord(parkingEntries[recordIndex][0])
    }

    getTableData(currentOccupation){
        var result = []
        for (var plate in currentOccupation){
            const row = [plate, currentOccupation[plate], "Eliminar"]
            result.push(row)
        }
        return result

    }

    componentDidUpdate(prevProps){
        const {currentOccupation} = this.props
        const {getTableData} = this
        if (prevProps !== this.props){
            const tableData = getTableData(currentOccupation)
            this.setState({
                parkingEntries: tableData
            })
        }
    }

    render(){
        const {parkingEntries} = this.state
        const {headers} = this
        return (
            <div>
                <div className="line-header-text">Placas registradas</div>
                <div>
                    <GenericTable
                        headers={headers}
                        tableData={parkingEntries}
                        columnOrderIndex={1}
                    />
                </div>
            </div>
        )
    }
}

export default ParkingRemove
